<template>
	<div class="w-100">
		<div
			v-for="(f, i) in flds.content"
			:key="i"
			class="w-100 p-3 overflow-hidden shadow border-15 mb-3"
			:class = "(f.status==1) ? ' bg-white ' : ' bg-brand-light '"
		>
			asdasdasdadsasd
		</div>
		<div class="w-100" style="display: flex; align-items: center; justify-content: center;">
		<pageNavigation :page="flds.curPage" :pages="flds.totalPages" @setPage="setPage"  />
	</div>
	</div>
</template>

	<script>
		import btn from  "../../../UI/button/btn.vue";
		import userImg from  "../../../UI/userImg/userImg.vue";
		import pageNavigation from  "../../../UI/pageNavigation/pageNavigation.vue";
		export default {
			name: 'teachers_part1',
			data(){
				return {

				}
			},
			components: {
				btn,
				pageNavigation,
				userImg,
			},
			props: {
				flds: {
					type: Object,
					default: null,
				},
			},
			mounted(){
				window.$('[data-toggle="tooltip"]').tooltip();
			},
			methods:{
				del_teacher(id, THIS = this) {
					this.$swal.fire({
						icon: '',
						title: "آیا حذف شود؟",
						showCancelButton: true,
						showCloseButton: true,
						confirmButtonText:"بلی",
						confirmButtonColor:"#aa000c",
						cancelButtonText:"بستن",
					}).then((result) => {
						if(result.value){
							window.$.post(window.baseurl + 'accountTeacher/step_teacher', {fild: 'status' ,val: 5, id: id}, function () {
								THIS.$emit('setPage', 1);
							}, "json");
						}
					})
				},	
				//********************************************************** */
				rtr(id){
					if(this.chechRole()){
						this.$router.push('/teachers/'+id)
					}
				},
				// *********************************************************************
				chechRole(){
					let user = this.$localStorage.get('user');
					if(user == null){
						return true;
					}else if(user.username.role != 3){
						return true;
					}else{
						return false;
					}
				},
				// *********************************************************************
				search(e){
					this.$emit('filterPage', e.target.value);
				},
				setPage(page){
					this.$emit('setPage', page);
				}
			}
		}
	</script>
<style>

</style>
